"use client";

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useApplePage } from "@/hooks/use-apple-page";
import { cn } from "@/lib/utils";

// "$4.99" -> 4.99, "4,99 €" -> 4.99, "$1,299.00" -> 1299. Apple sends the price as display text only.
function priceValue(price: string): number {
  const digits = price.replace(/[^\d.,]/g, "").replace(/,(?=\d{2}$)/, ".").replace(/,/g, "");
  const n = parseFloat(digits);
  return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY;
}

/** Every in-app purchase Apple lists for this app, cheapest first (owner 2026-09-18, tasks.md:1160). */
export function AppInAppPurchases({ appId, country, className }: { appId: number; country: string; className?: string }) {
  // Same query key as the reviews section, so this adds no request.
  const { data: apple } = useApplePage(appId, country);
  const iap = apple.inAppPurchases;
  if (!iap || iap.length === 0) return null;
  const rows = [...iap].sort((a, b) => priceValue(a.price) - priceValue(b.price) || a.name.localeCompare(b.name));

  return (
    <section className={cn("w-full", className)} aria-label="In-app purchases" data-testid="apple-iap-table">
      <h2 className="text-xl font-bold tracking-tight mb-3">In-app purchases</h2>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead className="text-right">Price</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((item, index) => (
            <TableRow key={`${item.name}-${item.price}-${index}`}>
              <TableCell className="whitespace-normal">{item.name}</TableCell>
              <TableCell className="text-right tabular-nums">{item.price}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </section>
  );
}
